import apiConfig from '../config/config'
import axios from 'axios'
const publicPages = ["resetPassword", "validateTeam", "signup", "activate", "authenticate",
    "companySignup", "createUser", "validateEmail",
    "findAllUser", "password", "checkUser", "authenticateFirebase", "authInfo"]
import moment from 'moment'
var ApiService = {
    refreshToken: async function ($url, $options) {

        var $tiburaUser = JSON.parse(localStorage.getItem(process.env.VUE_APP_LOCAL_STORAGE))
        let $a = { headers: { "appKey": apiConfig.appKey, "refresh_token": $tiburaUser.data.User.refresh_token ? $tiburaUser.data.User.refresh_token : "Abctoken" } }
        return await axios.get($url, $a)
            .then(response => {
                //console.log($tibmduraUser)
                ///$tiburaUser.data.token=response.data.token
                localStorage.setItem(process.env.VUE_APP_LOCAL_STORAGE, JSON.stringify(response))
                $options.url = $options.url.replace(apiConfig.baseUrl + "/", '')
                return ApiService.request($options)
            })
            .catch(error => {
                console.log(error);
                return Promise.reject(error);
            });

    },
    request: function ($options) {
        return new Promise(function (resolve, reject) {
            //$options.appKey = apiConfig.apiKey;
            //$options.token = apiConfig.token;
            if (publicPages.indexOf($options.url) >= 0) {

                var headers = {
                    'Content-Type': 'application/json',
                    'appkey': apiConfig.appKey,
                    'client_id': localStorage.getItem('CLIENT_ID')
                }
            }
            else if ($options.url.indexOf('resetPassword') >= 0 ||

                $options.url.indexOf('companySignup') >= 0 ||
                $options.url.indexOf('validateEmail') >= 0 ||
                $options.url.indexOf('authenticate') >= 0 ||
                $options.url.indexOf('sendOtp') >= 0 ||
                $options.url.indexOf('verifyOtp') >= 0 ||

                $options.url.indexOf('validateTeam') >= 0 ||
                $options.url.indexOf('createUser') >= 0 ||
                $options.url.indexOf('findAllUser') >= 0 ||
                $options.url.indexOf('password') >= 0 ||
                $options.url.indexOf('authInfo') >= 0 ||


                $options.url.indexOf('activate') >= 0 ||
                $options.url.indexOf('signup') >= 0 ||
                $options.url.indexOf('checkUser') >= 0) {

                var headers = {
                    'Content-Type': 'application/json',
                    'appkey': apiConfig.appKey,
                    'client_id': localStorage.getItem('CLIENT_ID')
                }
            }
            else {
                var $tiburaUser = JSON.parse(localStorage.getItem(process.env.VUE_APP_LOCAL_STORAGE))
                console.log(moment().diff($tiburaUser.data.expiresOn, 'minutes'), 'pppppp')
                if (moment().diff($tiburaUser.data.expiresOn, 'minutes') > 0) {
                    //   alert(process.env.VUE_APP_ONEAPP_DOMAIN)

                    window.location = process.env.VUE_APP_ONEAPP_DOMAIN
                } else {
                    var $token = $tiburaUser.data.token
                    var headers = {
                        'Content-Type': 'application/json',
                        'Authorization': $token,
                        'appkey': apiConfig.appKey,
                        'client_id': localStorage.getItem('CLIENT_ID')
                    }
                }
            }
            $options.url = apiConfig.baseUrl + "/" + $options.url;
    /*if($options.responseType) {
        headers.responseType= 'arraybuffer'
        headers.accept ="application/pdf"
        }
      */      console.log($options)
            if ($options.method == 'post') {
                axios.post($options.url, $options.data, { headers: headers })
                    .then(response => {
                        //console.log(response);
                        resolve(response);
                    })
                    .catch(error => {
                        console.log(error);
                        if (error.response.status == 401) {
                            resolve(ApiService.refreshToken($options.url, $options))
                        } else {
                            reject(error)
                        }
                    });
            } else if ($options.method == 'delete') {
                // axios.delete($options.url,$options.data,{headers:headers})
                axios.delete($options.url, { "headers": headers })
                    .then(response => {
                        //console.log(response);
                        resolve(response);
                    })
                    .catch(error => {
                        console.log(error);
                        if (error.response.status == 401) {
                            resolve(ApiService.refreshToken($options.url, $options))
                        } else {
                            reject(error)
                        }
                    });
            } else if ($options.method == 'put') {
                axios.put($options.url, $options.data, { headers: headers })
                    .then(response => {
                        //console.log(response);
                        resolve(response);
                    })
                    .catch(error => {
                        console.log(error);
                        if (error.response.status == 401) {
                            resolve(ApiService.refreshToken($options.url, $options))
                        } else {
                            reject(error)
                        }
                    });
            }
            else {
                var $h = {}
                if ($options.responseType) {
                    $h = { responseType: "blob", headers: headers }
                } else {
                    $h = { headers: headers }
                }
                axios.get($options.url, $h)
                    .then(response => {
                        // console.log(response);
                        resolve(response);
                    })
                    .catch(error => {
                        console.log(error);
                        if (error.response.status == 401) {
                            resolve(ApiService.refreshToken($options.url, $options))
                        }
                        if (error.response.status == 406) {
                            //resolve(ApiService.refreshToken($options.url,$options))
                            $tiburaUser.data.ipDenied = true
                            localStorage.setItem(process.env.VUE_APP_LOCAL_STORAGE, JSON.stringify($tiburaUser))
                        }
                        else {
                            reject(error)
                        }
                    });
            }


        });


    }
};
export default ApiService;